module.exports = __webpack_public_path__ + "static/img/login_pic_logo.e9ca7756.svg";